module.exports = __webpack_public_path__ + "img/PC6.54c56bd4.png";